import {Component, OnInit, Inject} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {Router} from '@angular/router';
import {AuthService} from './guard/auth.service';
import {MatDialog, MAT_DIALOG_DATA} from '@angular/material';
import {IAuth} from './shared/auth';

@Component({
  selector: 'app-logout-dialog-message',
  templateUrl: './logout-dialog.component.html',
  styleUrls: ['./logout-dialog.component.css']
})
export class LogoutDialogComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: any) { }
}

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  navLinks = [
    {label: 'Key Stats', path: '/home'},
    {label: 'Match', path: '/match'},
    {label: 'Quarantine', path: '/quarantine'},
    {label: 'History', path: '/history'}
  ];

  isLoggedIn$: Observable<string>;

  constructor(private router: Router, private authService: AuthService, private dialog: MatDialog) {}

  ngOnInit() {
    this.isLoggedIn$ = Observable.create(
      (observer) => {
        this.authService.isLoggedIn().subscribe(res => observer.next(res != null ? res.username : null));
      }
    );
  }

  logoutDialog() {
    this.dialog.open(LogoutDialogComponent, {
      width: '500px',
      data: {}
    }).afterClosed().subscribe(res => {
      if (res) {
        this.logout();
      }
    });
  }

  logout() {
    this.authService.logout();
    sessionStorage.clear();
    localStorage.setItem('removeSessionStorage', 'startProcess');
    localStorage.removeItem('removeSessionStorage');
    this.router.navigate(['login']);
  }

}



// WEBPACK FOOTER //
// ./src/app/app.component.ts